import { memo } from 'react';
import { Box } from '@chakra-ui/react';

import Cross from 'components/Icons/Cross';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../../constants';

export interface InputPanelCloseButtonV1Properties {
  onClick: () => void;
  'aria-label'?: string;
}

const InputPanelCloseButtonV1 = memo(
  ({
    onClick,
    'aria-label': ariaLabel = 'Close input panel',
  }: InputPanelCloseButtonV1Properties) => (
    <Box
      as='button'
      type='button'
      aria-label={ariaLabel}
      onClick={onClick}
      display='flex'
      alignItems='center'
      justifyContent='center'
      w={BUILDER_MODE_V1_LAYOUT.inputPanelCloseButtonSize}
      h={BUILDER_MODE_V1_LAYOUT.inputPanelCloseButtonSize}
      minW={BUILDER_MODE_V1_LAYOUT.inputPanelCloseButtonSize}
      minH={BUILDER_MODE_V1_LAYOUT.inputPanelCloseButtonSize}
      p='10px'
      bg={BUILDER_MODE_V1_TOKENS.white}
      border='1px solid'
      borderColor={BUILDER_MODE_V1_TOKENS.border}
      borderRadius='32px'
      cursor='pointer'
      flexShrink={0}
      _hover={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
    >
      <Cross height='10px' width='10px' bgColor={BUILDER_MODE_V1_TOKENS.textDark} fillOpacity={1} />
    </Box>
  ),
);

InputPanelCloseButtonV1.displayName = 'InputPanelCloseButtonV1';

export default InputPanelCloseButtonV1;
